// Globals
import React from 'react';

// UI

// Locals

// Types

const AccountSettings: React.FC = () => {
  return <></>;
};

export default AccountSettings;
